type IdentityLike = Record<string, unknown> | null | undefined;

function compactIdentityValues(values: unknown[]): string[] {
  return values.map((value) => String(value || "").trim()).filter(Boolean);
}

export function getPatientIdentityIds(patient: IdentityLike): string[] {
  return compactIdentityValues([
    patient?.patient_id,
    patient?.patientId,
    patient?.id,
    patient?._id,
  ]);
}

export function getRecordPatientId(record: IdentityLike): string {
  return (
    compactIdentityValues([record?.patient_id, record?.patientId])[0] || ""
  );
}

export function getRecordIdentity(record: IdentityLike): string {
  const explicitId = record?.id || record?._id || record?.record_id;
  if (explicitId) return String(explicitId);

  const patientId = getRecordPatientId(record);
  const visitDate = String(record?.visit_date || record?.visitDate || "");
  return patientId || visitDate ? `${patientId}:${visitDate}` : "";
}

/**
 * 患者与病历的一致性只由稳定 ID 决定，姓名等展示快照不参与身份判断。
 */
export function isRecordPatientIdentityAligned(
  patient: IdentityLike,
  record: IdentityLike,
): boolean {
  if (!record) return true;
  if (!patient) return false;

  const patientIds = getPatientIdentityIds(patient);
  const recordPatientId = getRecordPatientId(record);
  if (!recordPatientId || patientIds.length === 0) return false;

  return patientIds.includes(recordPatientId);
}

/**
 * 判断异步操作开始时的病历在完成时是否仍为当前病历。
 */
export function isSameRecord(
  expected: IdentityLike,
  current: IdentityLike,
): boolean {
  const expectedId = getRecordIdentity(expected);
  return Boolean(expectedId) && expectedId === getRecordIdentity(current);
}
